<template>
	<div class="inputs-row fd-lang-area">
		<textarea v-if="visible" :rows="initialRows" v-model="intlValue" :class="[clazz, errorClass]" :style="style"
				  :readonly="ro" ref="area_tag" v-bind="attrs"></textarea>

		<select v-model="langValue" v-bind="tabindexBinding(1)" @change="changeLanguage(area_tag,langValue)">
			<option v-for="lang in languages" :value="lang">{{lang}}</option>
		</select>
	</div>
</template>

<script setup lang="ts">
import autosize from "autosize";
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed, nextTick, onMounted, ref} from "vue";
import type {IntlTextArea} from "@t/fd/editor/IntlTextArea";
import type {IntlItem} from "@t/fd/editor/IntlInput";
import { useBaseIntl } from './IntlBase';

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const intlArea = computed<IntlTextArea>(() => props.part as IntlTextArea);
const intlValues = computed<IntlItem[]>(() => value.value as IntlItem[]);

const area_tag = ref(null);
const langValue = ref<string>(null);

const {visible, value, clazz, errorClass, style, ro, tabindexBinding} = useEditor(props);

const {languages, changeLanguage, initLanguage} = useBaseIntl();

const initialRows = computed(() => {
    if (typeof intlArea.value.rows === "number") return intlArea.value.rows;
    return intlArea.value.autosize ? 1 : 2;
});

const attrs = computed(() => {
    const a: any = tabindexBinding();
    if (typeof intlArea.value.placeholder === "string") a.placeholder = intlArea.value.placeholder;
    if (typeof intlArea.value.maxLength === "number") a.maxlength = intlArea.value.maxLength;
	return a;
});

const intlValue = computed<string>({
	get():string {
		if (Array.isArray(intlValues.value)) {
			let item:IntlItem = intlValues.value.find(item => item.lang === langValue.value);
			if (item) return item.title;
		}
		return '';
	},
	set(v:string):void {
		if (!Array.isArray(intlValues.value)) {
			value.value = [];
		}
		
		let item:IntlItem = intlValues.value.find(item => item.lang === langValue.value);
		if (item) {
			item.title=v;
		}
		else {
			let newItem: IntlItem = {lang: langValue.value,title: v};
			intlValues.value.push(newItem);
		}
	}
});

//init actual CRM language
langValue.value = initLanguage();

onMounted(() => {
    const ar: boolean = typeof intlArea.value.autosize === "boolean" ? intlArea.value.autosize : true;
    if (area_tag.value && ar) {
        nextTick(() => {
            if (area_tag.value) autosize(area_tag.value);
        });
    }
});
</script>

<style>
.fd-lang-area {
	& > select {
		border-left: 1px solid var(--border-color);
		border-bottom: 1px solid var(--border-color);
		color: var(--footer-bg);
	}
}
</style>

